export const getInsightsCardMapForSection = num => {
  const cardsNames = insightsSections[num];

  return getCardMapForSection(insightsCardsMap, cardsNames);
};

export const getSalesInsightsCardMapForSection = num => {
  const cardsNames = salesInsightsSections[num];

  return getCardMapForSection(salesInsightsCardsMap, cardsNames);
};

export const getInsightsCardForTitle = title => {
  return getCardForTitle(insightsCardsMap, title);
};

export const getSalesInsightsCardForTitle = title => {
  return getCardForTitle(salesInsightsCardsMap, title);
};

const insightsSections = [
  [
    'pageViews',
    'measurableViews',
    'purchaseIntentClicks',
    'purchaseIntentRate',
    'purchaseIntentValue',
  ],
  [
    'topPlatforms',
    'topRetailers',
    'topPlayers',
    'campaignPerformance',
  ],
  [
    'channelTypePerformance',
    'campaignObjectivePerformance',
    'audiencePerformance',
    'dmaPerformance',
    'geoPerformance',
    'influencerPerformance',
    'productPerformance',
  ],
];

const salesInsightsSections = [
  [
    'totalAttributableSales',
    'avgBasketSize',
    'avgOrderValue',
    'avgUnitPrice',
    'totalAttributableUnitsSold',
  ],
  [
    'totalAttributableSales',
    'totalAttributableUnitsSold',
  ],
  [
    'topPlatforms',
    'topRetailers',
  ],
  [
    'topCampaigns',
  ],
  [
    'topCategories',
    'geoPerformance',
  ],
  [
    'deviceType',
    'appType',
  ],
  [
    'topBrandProducts',
    'topNonBrandProducts',
  ],
];

export const insightsCardsMap = {
  pageViews: {
    title: 'Page Views',
    tooltip: 'Number of views a MikMak Commerce Experience receives',
    initialSort: 'event_date',
    dimensions: ['eventDate'],
    metrics: ['pageViews'],
  },
  measurableViews: {
    title: 'Measurable Views',
    tooltip: 'Number of viewers trackable for MikMak Commerce based on consumer privacy regulations',
    initialSort: 'event_date',
    dimensions: ['eventDate'],
    metrics: ['measurableViews'],
  },
  purchaseIntentClicks: {
    title: 'Purchase Intent Clicks',
    tooltip: 'The number of times a shopper has clicked through to at least one retailer during a single session.',
    initialSort: 'event_date',
    dimensions: ['eventDate'],
    metrics: ['purchaseIntentClicks'],
  },
  purchaseIntentRate: {
    title: 'Purchase Intent Rate',
    tooltip: 'The percentage of shoppers who clicked through to at least one retailer.',
    initialSort: 'event_date',
    dimensions: ['eventDate'],
    metrics: ['purchaseIntentRate'],
  },
  purchaseIntentValue: {
    title: 'Purchase Intent Value',
    tooltip:
      'The potential dollar value of the product selected by a shopper when clicking through to a retailer, calculated by multiplying the listed SKU Price and the total number of Purchase Intent Clicks.',
    initialSort: 'event_date',
    dimensions: ['eventDate'],
    metrics: ['purchaseIntentValue'],
  },
  topPlatforms: {
    title: 'Platforms',
    tooltip:
      'Top Platforms shows a breakdown of Measurable Views and Purchase Intent Rate ' +
      'broken out by the platforms/environments users are coming from.',
    class: 'top-platforms',
    initialSort: 'measurable_views',
    dimensions: ['platformName'],
    metrics: ['measurableViews', 'purchaseIntentClicks', 'shareOfPurchaseIntentClicks', 'purchaseIntentRate'],
  },
  topRetailers: {
    title: 'Retailers',
    tooltip:
      'Top Retailers shows the amount of times each retailer has loaded in a MikMak Experience, ' +
      'the  percent of shoppers who have clicked to shop by retailer, including Purchase Intent Clicks',
    class: 'top-retailers',
    initialSort: 'retailer_displayed',
    dimensions: ['cartName'],
    metrics: ['retailerDisplayed', 'purchaseIntentClicks', 'shareOfPurchaseIntentClicks', 'retailerPurchaseIntentRate'],
  },
  topPlayers: {
    title: 'Experiences',
    tooltip:
      'Top MikMak Commerce Experiences shows the Purchase Intent Rate Percent ' +
      'for the experiences with the highest number for Measurable Views.',
    class: 'top-mikmak-experience',
    initialSort: 'measurable_views',
    dimensions: ['experienceNameWithLink'],
    metrics: ['measurableViews', 'purchaseIntentClicks', 'shareOfPurchaseIntentClicks', 'purchaseIntentRate'],
  },
  channelTypePerformance: {
    title: 'Channels',
    tooltip:
      'Channel Performance shows the number of Measurable Views and Purchase Intent Rate ' +
      'broken out by the campaign\'s channel.',
    initialSort: 'measurable_views',
    dimensions: ['channelType'],
    metrics: ['measurableViews', 'purchaseIntentRate'],
  },
  campaignPerformance: {
    title: 'Campaigns',
    tooltip:
      'Campaign Performance shows the Purchase Intent Rate Percent for the campaigns with ' +
      'the highest number for Measurable Views.',
    initialSort: 'measurable_views',
    dimensions: ['campaignName'],
    metrics: ['measurableViews', 'shareOfPurchaseIntentClicks', 'purchaseIntentRate'],
    section: 3,
  },
  campaignObjectivePerformance: {
    title: 'Campaign Objectives',
    tooltip:
      'Campaign Objective Performance shows the Measurable Views and Purchase Intent Rate for the campaigns with ' +
      'the highest number for Shoppers Measured.',
    initialSort: 'measurable_views',
    dimensions: ['campaignObjectiveType'],
    metrics: ['measurableViews', 'purchaseIntentRate'],
  },
  audiencePerformance: {
    title: 'Audiences',
    tooltip:
      'Audience Performance shows the number of Measurable Views and ' +
      'the Purchase Intent Rate broken out by audience.',
    initialSort: 'measurable_views',
    dimensions: ['audience'],
    metrics: ['measurableViews', 'purchaseIntentRate'],
  },
  dmaPerformance: {
    title: 'DMAs',
    tooltip:
      'DMA Performance shows a breakdown of Measurable Views and Purchase Intent Rate by DMA.',
    initialSort: 'measurable_views',
    dimensions: ['dmaAmplitude'],
    metrics: ['measurableViews', 'purchaseIntentRate'],
    isForUSBrandsOnly: true,
  },
  geoPerformance: {
    title: 'Geo Performance',
    tooltip:
      'Geo Performance shows a breakdown of Measurable Views and Purchase Intent Rate by City and Country',
    initialSort: 'measurable_views',
    dimensions: ['cityAndRegion'],
    metrics: ['measurableViews', 'purchaseIntentRate'],
    isForNonUSBrandsOnly: true,
  },
  influencerPerformance: {
    title: 'Handles',
    tooltip:
      'Handle Performance shows the number of Measurable Views, Purchase Intent Clicks, ' +
      'and the Purchase Intent Rate broken out by handle.',
    initialSort: 'measurable_views',
    dimensions: ['handle'],
    metrics: ['measurableViews', 'purchaseIntentRate'],
  },
  // TODO: add back when API is updated
  // productPerformance: {
  //   title: 'Products',
  //   tooltip:
  //     'Product Performance shows the number of Page Views per experiences and ' +
  //     'the Purchase Intent Rate broken out by product.',
  //   initialSort: 'page_views',
  //   dimensions: ['productName'],
  //   metrics: ['purchaseIntentClicks'],
  // },
  shopperIntelligence: {
    title: 'Shopper Intelligence',
    tooltip:
      'Shopper Intelligence, Gender, and Age data are gathered from LiveRamp, a third party data provider. ' +
      'This data is not linked to  your existing MikMak audiences. ' +
      'The aforementioned data is based on consumers who matched to external datasets, ' +
      'therefore you may notice differences in reported numbers compared to other areas of MikMak Insights.',
    initialSort: 'page_views',
    dimensions: ['allSegments'],
    metrics: ['pageViews', 'purchaseIntentRate'],
  },
  gender: {
    title: 'Gender',
    tooltip:
      'Shopper Intelligence, Gender, and Age data are gathered from LiveRamp, a third party data provider. ' +
      'This data is not linked to  your existing MikMak audiences. ' +
      'The aforementioned data is based on consumers who matched to external datasets, ' +
      'therefore you may notice differences in reported numbers compared to other areas of MikMak Insights.',
    initialSort: 'page_views',
    dimensions: ['gender'],
    metrics: ['pageViews'],
  },
  age: {
    title: 'Age',
    tooltip:
      'Shopper Intelligence, Gender, and Age data are gathered from LiveRamp, a third party data provider. ' +
      'This data is not linked to  your existing MikMak audiences. ' +
      'The aforementioned data is based on consumers who matched to external datasets, ' +
      'therefore you may notice differences in reported numbers compared to other areas of MikMak Insights.',
    initialSort: 'page_views',
    dimensions: ['age'],
    metrics: ['pageViews'],
  },
};

export const salesInsightsCardsMap = {
  totalAttributableSales: {
    title: 'Attributable Sales',
    tooltip: 'The total tracked sales value from Transactions that occured within the retailer-defined attribution window.',
    class: 'attributable-sales',
    initialSort: 'event_date',
    dimensions: ['eventDate'],
    metrics: ['attributableSales'],
    view: 'Explorer',
  },
  totalAttributableUnitsSold: {
    title: 'Attributable Units Sold',
    tooltip: 'The total number of individual units (i.e. products) from Transactions that occured within the retailer-defined attribution window.',
    class: 'attributable-units-sold',
    initialSort: 'event_date',
    dimensions: ['eventDate'],
    metrics: ['attributableUnitsSold'],
    view: 'Explorer',
  },
  avgBasketSize: {
    title: 'Average Basket Size',
    tooltip: 'Average number of units in a basket',
    class: 'avg-basket-size',
    initialSort: 'event_date',
    dimensions: ['eventDate'],
    metrics: ['avgBasketSize'],
    view: 'Explorer',
  },
  avgOrderValue: {
    title: 'Average Order Value',
    tooltip: 'Average total cost of a basket',
    class: 'avg-order-value',
    initialSort: 'event_date',
    dimensions: ['eventDate'],
    metrics: ['avgOrderValue'],
    view: 'Explorer',
  },
  avgUnitPrice: {
    title: 'Average Unit Price',
    tooltip: 'Average price of an individual unit',
    class: 'avg-unit-price',
    initialSort: 'event_date',
    dimensions: ['eventDate'],
    metrics: ['avgUnitPrice'],
    view: 'Explorer',
  },
  topPlatforms: {
    title: 'Platforms',
    tooltip: 'Top performing platforms by attributable units sold and attributable sales',
    class: 'platform-performance',
    initialSort: 'attributable_sales',
    dimensions: ['platformName'],
    metrics: ['attributableSales', 'percentOfSales'],
    view: 'Explorer',
  },
  topRetailers: {
    title: 'Retailers',
    tooltip: 'A breakdown of sales metrics by retailer',
    class: 'retailer-performance',
    initialSort: 'attributable_sales',
    dimensions: ['cartName'],
    metrics: ['attributableSales', 'percentOfSales'],
    view: 'Explorer',
  },
  topCampaigns: {
    title: 'Campaigns',
    tooltip: 'Top performing campaigns by attributable units sold and attributable sales',
    class: 'campaign-performance',
    initialSort: 'attributable_sales',
    dimensions: ['campaignName'],
    metrics: ['attributableSales', 'percentOfSales'],
    view: 'Explorer',
  },
  topCategories: {
    title: 'Categories',
    tooltip: 'Top performing product categories by attributable units sold and attributable sales',
    class: 'category-performance',
    initialSort: 'pct_of_attributable_sales',
    dimensions: ['categoryName'],
    metrics: ['percentOfAttributableSales', 'percentOfSales'],
    view: 'Explorer',
  },
  geoPerformance: {
    title: 'Geos',
    tooltip: 'Top performing cities by attributable units sold and attributable sales',
    class: 'geo-performance',
    initialSort: 'pct_of_attributable_sales',
    dimensions: ['dmaAmplitude'],
    metrics: ['percentOfAttributableSales', 'percentOfSales'],
    view: 'Explorer',
  },
  deviceType: {
    title: 'Device Performance',
    tooltip: 'Breakdown of metrics by device type',
    class: 'device-performance',
    initialSort: 'pct_of_attributable_sales',
    dimensions: ['device'],
    metrics: ['percentOfAttributableSales', 'percentOfSales'],
    view: 'Explorer',
  },
  appType: {
    title: 'App Performance',
    tooltip: 'Breakdown of metrics by app or browser usage',
    class: 'app-performance',
    initialSort: 'pct_of_attributable_sales',
    dimensions: ['appType'],
    metrics: ['percentOfAttributableSales', 'percentOfSales'],
    view: 'Explorer',
  },
  topBrandProducts: {
    title: 'Brand Products',
    tooltip: 'Top selling brand-specific products being purchased through an experience',
    class: 'brand-products',
    initialSort: 'attributable_sales',
    dimensions: ['productName'],
    metrics: ['attributableSales', 'percentOfSales'],
    filters: [{ key: 'skuBrandAssociation', value: ['Is Brand Sku'], operator: 'includes' }],
    view: 'Explorer',
  },
  topNonBrandProducts: {
    title: 'Non-Brand Products',
    tooltip: 'Top selling non-brand products being purchased through an experience',
    class: 'non-brand-products',
    initialSort: 'attributable_sales',
    dimensions: ['productName'],
    metrics: ['attributableSales', 'percentOfSales'],
    filters: [{ key: 'skuBrandAssociation', value: ['Is Not Brand Sku'], operator: 'includes' }],
    view: 'Explorer',
  },
};

const getCardMapForSection = (cardMap, cardsNames) => {
  return cardsNames.reduce((sectionMap, cardName) => {
    const card = cardMap[cardName];

    if (card) {
      sectionMap[cardName] = card;
    }

    return sectionMap;
  }, {});
};

const getCardForTitle = (cardMap, title) => {
  return Object.values(cardMap).find(c => c.title === title);
};
